import { Apartment } from '@/models/apartment.model';
import { ViewsInfo } from '@/models/views-info.model';

class ApartmentService {
    apartment: Apartment = {
        internalNumber: '',
        name: '',
        mappingName: '',
        id: 0,
        symbol: '',
        numberOfViews: 1,
    };

    public setData(apartment: Apartment) {
        this.apartment = apartment;
    }

    public setNumberOfViewsFromViewsInfo(viewsInfo: ViewsInfo) {
        const matched = viewsInfo.views
            .find((view) => view.MappingName === this.apartment.mappingName);

        this.apartment.numberOfViews = matched?.WindowViews || 1;
    }

    public get isDefined() {
        return !!this.apartment;
    }
}

export default ApartmentService;
